<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="datetime-field-config">
		<vs-row class="pt-2">
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME.TYPE_DATETIME" v-model="localTypeValue">{{ $t("FieldConfig.Datetime") }}</vs-radio>
			</vs-col>
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME.TYPE_DATE" v-model="localTypeValue">{{ $t("FieldConfig.Date") }}</vs-radio>
			</vs-col>
			<vs-col vs-w="4" vs-xs="12">
				<vs-radio vs-name="type" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME.TYPE_TIME" v-model="localTypeValue">{{ $t("FieldConfig.Time") }}</vs-radio>
			</vs-col>
		</vs-row>

		<div class="my-5">
			<legend>{{ $t("FieldConfig.ValueCanSelect") }}:</legend>
			<vs-row class="pt-2">
				<vs-col vs-w="6" vs-xs="12" v-if="localTypeValue !== $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME.TYPE_TIME">
					<vs-radio vs-name="validationType" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME_VALIDATION.TYPE_DATE_RANGE" v-model="localValidationModeValue">{{ $t("FieldConfig.DateRange") }}</vs-radio>
				</vs-col>
				<vs-col vs-w="6" vs-xs="12">
					<vs-radio vs-name="validationType" :vs-value="$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME_VALIDATION.TYPE_AFTER_CURRENT_TIME" v-model="localValidationModeValue">{{ $t("FieldConfig.AfterCurrentTime") }}</vs-radio>
				</vs-col>
			</vs-row>

			<div class="validation-config datetime-field-config__validation-config bg-gray-6 p-6 mt-3 rounded">
				<cbs-date-range-picker
					v-if="localValidationValue.mode === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME_VALIDATION.TYPE_DATE_RANGE"
					type="date"
					prefix-icon="''"
					format="dd/MM/yyyy"
					value-format="yyyy-MM-dd"
					:value="localValidationDateRangeValue"
					:toLabel="`${$t('FieldConfig.ToDate')}:`"
					:fromLabel="`${$t('FieldConfig.FromDate')}:`"
					:toPlaceholder="`${$t('Actions.Choose')} ${$t('FieldConfig.ToDate').toLowerCase()}`"
					:fromPlaceholder="`${$t('Actions.Choose')} ${$t('FieldConfig.FromDate').toLowerCase()}`"
					@change="handleChangeValidationDateRange"
				/>

				<div 
					class="after-current-time" 
					v-else-if="localValidationValue.mode === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME_VALIDATION.TYPE_AFTER_CURRENT_TIME"
				>
					<legend>{{ $t("FieldConfig.NumberOfHours") }}:</legend>
					<vx-input-group class="after-current-time validation-config__after-current-time">
						<template slot="append">
							<div class="append-text text-black bg-white">{{ $t('FieldConfig.Hour') }}</div>
						</template>

						<cbs-input
							type="number"
							v-validate="{
								integer: true,
								min_value: 1
							}"
							name="after-current-time"
							v-model="localValidationFromNowValue"
							:data-vv-as="$t('FieldConfig.NumberOfHours')"
							:placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.NumberOfHours')}`"
						/>
					</vx-input-group>
					<span class="text-danger text-sm">{{ errors.first("after-current-time") }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	inject: ["parentValidator"],
	name: "DatetimeFieldConfig",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("type") && prop.hasOwnProperty("validation")
		}
	},
	computed: {
		localTypeValue: {
			get() {
				return this.value.type;
			},
			set(val) {
				this.$emit("input", { ...this.value, type: val });
			}
		},
		localValidationValue: {
			get() {
				return this.value.validation;
			},
			set(val) {
				this.$emit("input", { ...this.value, validation: val });
			}
		},
		localValidationModeValue: {
			get() {
				return this.localValidationValue.mode;
			},
			set(val) {
				this.$emit("input", { ...this.value, validation: { ...this.localValidationValue, mode: val }});
			}
		},
		localValidationFromNowValue: {
			get() {
				return this.localValidationValue.from_now && this.localValidationValue.from_now.value;
			},
			set(val) {
				this.$emit("input", { ...this.value, validation: { ...this.localValidationValue, from_now: { ...this.localValidationValue.from_now, value: val} }});
			}
		},
		localValidationDateRangeValue: {
			get() {
				return [this.localValidationValue.min, this.localValidationValue.max];
			},
			set(val) {
				this.$emit("input", { ...this.value, validation: {
					...this.value.validation,
					min: val[0],
					max: val[1],
				}});
			}
		}
	},
	watch: {
		localTypeValue() {
			if (this.localTypeValue === this.$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME.TYPE_TIME) {
				this.localValidationModeValue = this.$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.DATETIME_VALIDATION.TYPE_AFTER_CURRENT_TIME;
			}
		}
	},
	methods: {
		handleChangeValidationDateRange(val) {
			this.localValidationDateRangeValue = val;
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss" scoped>
.datetime-field-config {
	.after-current-time {
		::v-deep .vx-input-group-append {
			border-left: 1px solid rgba(0, 0, 0, 0.2);
		}
	}
}
</style>